// extracted by mini-css-extract-plugin
module.exports = {"root":"MessageReply_root__3hwZk","close":"MessageReply_close__1JEuN","inner":"MessageReply_inner__3qwMW","replyIcon":"MessageReply_replyIcon__1ICUp"};